import { redirect } from 'react-router';

import { prepareAuth } from './prepare-auth-loader';

/**
 * If the user in NOT connected and tries to access `/app`,
 * we redirect to `/login`
 */
export async function protectedLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect('/login');
  }
  // const isTrial = await checkUserAccess();

  // if (!isTrial) {
  //   return redirect('/login');
  // }

  return null;
}
